import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'

import { ConfigProvider } from '../../providers/config/config'

import { Address, AddressOwnerType, AddressType } from '../../models/models'
import { Observable } from 'rxjs/Observable'

@Injectable()
export class AddressProvider {
	constructor(
		public http: HttpClient
	) {
	}

	/**
	Elimina un indirizzo dal database
	*/
	public destroy(address: Address): Promise<boolean> {
		console.log("Eliminazione dell'indirizzo:", address)
		let self = this
		return new Promise<boolean>((resolve, reject) => {
			let request = self.http.post(ConfigProvider.HOST + "/address/" + address.id + "/destroy", { confirm: true })
			request.subscribe(
				deleted => {
					if(!deleted) {//Chiamata ok ma non ha trovato il dispositivo
						console.warn("Indirizzo non trovato: ", address)
						resolve(false)
						return
					}
					resolve(true)
				}, error => {
					console.error("Errore eliminando l'indirizzo: ", error)
					resolve(false)
				}
			)
		})
	}


	public indexOwned(
		id: number,
		ownerType: AddressOwnerType,
		type: AddressType,
		loads: string[] = null,
		pagesize: number = 10,
		before: Address = null,
		after: Address = null
	): Promise<Address[]> {
		console.debug('[AddressProvider.indexOwned()] Recupero degli indirizzi appartenenti ' + ownerType + ' di tipo "' + type + '": ' + { id: id, ownerType: ownerType, type, loads, pagesize, before, after })

		let url = ConfigProvider.HOST + "/address/" + ownerType + "/" + id + "/" + type
		return this.index(url, 'GET', loads, pagesize, before, after)
	}

	/*
	Responsabilità: Recupera una sequenza di indirizzi, eventualmente la inizializza e restituisce la promise per risolverla
	Requisiti: può essere usato con qualunque url che restituisca una sequenza di indirizzi
	*/
	private index(
		url: string,
		method: string = 'GET',
		loads: string[] = [],
		pagesize: number = null,
		before: Address = null,
		after: Address = null,
	): Promise<Address[]> {
		let params = new HttpParams()

		if(loads && loads.length > 0) {//aggiunge eventuali relazioni da caricare
			for(let load of loads) {
				params = params.append('loads[]', load)
			}
		}


		if(before) {//precedenti a questo
			params = params.set('before', before.id.toString())
		}

		if(pagesize) {//numero massimo di risultati
			params = params.set('pagesize', pagesize.toString())
		}

		if(after) {//dopo di questo
			params = params.set('after', after.id.toString())
		}

		console.debug('[AddressProvider.index()] Recupero i messaggi dalla URL: ' + url, params)

		let request: Observable<Address[]> = null
		let self = this

		switch(method) {
			case 'GET':
				request = this.http.get<Address[]>(url, { params: params })
				break
			case 'POST':
				request = this.http.post<Address[]>(url, params)
				break
			default:
				console.error("Metodo HTTP non riconosciuto: " + method)
				break
		}

		return new Promise<Address[]>((resolve, reject) => {
			request.subscribe(
				addresses => {
					if(!addresses) {//Chiamata ok ma non ha trovato l'utente
						console.warn("Indirizzi non trovati tramite URL: " + url)
						resolve(addresses)
						return
					}

					for(let address of addresses) {
						self.init(address)
					}

					resolve(addresses)
				}, error => {
					console.warn("Errore recuperando gli indirizzi da URL: " + url, error)
					reject(error)
				})
		})
	}


	/**
	Inizializza un messaggio dopo averlo caricato da server
	*/
	private init(address: Address): Address {
		return address
	}

	public save(address: Address) {
		if(address.id) {
			return this.update(address)
		} else {
			return this.store(address)
		}
	}

	public store(address: Address) {
		return this.http.post(ConfigProvider.HOST + "/address/store", address)
	}
	public update(address: Address) {
		return this.http.post(ConfigProvider.HOST + "/address/" + address.id + "/update", address)
	}
}



// WEBPACK FOOTER //
// ./src/providers/address/address.ts